// src/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='footer-container'>
      
      <p>Follow us on Instagram for updates and share the event with your friends!</p>
    </footer>
  );
};

export default Footer;
